import axios from "axios";

export const fetchGenres = async () => {
  const { data } = await axios.get(
    `${process.env.REACT_APP_API_BASE_URL}/products/genres`
  );
  return data;
};
